import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum SwMessageTypes {
    SyncDataUpdate = "SyncDataUpdate",
    OnlineStateChanged = "OnlineStateChanged"
}

@Injectable({ providedIn: 'root' })
export class SwMessenger
{
    private message = new BehaviorSubject(null);
    private serviceWorker: ServiceWorker;

    constructor() {
        if ('serviceWorker' in navigator) {
            (<Navigator>navigator).serviceWorker.addEventListener("message", (event) => {
                this.message.next(event.data);
            });

            (<Navigator>navigator).serviceWorker.ready.then((registration: ServiceWorkerRegistration) => {
                this.serviceWorker = registration.active;
            });
        }
    }

    postMessage(obj: object) {
        if (!this.serviceWorker || !obj) {
            return;
        }

        this.serviceWorker.postMessage(obj);
    }

    postMessageToAllClients(clients: Clients, obj: object) {
        if (!clients || !obj) {
            return;
        }

        clients.matchAll().then(clients => {
            clients.forEach(client => {
                client.postMessage(obj);
            });
        });
    }

    messageQueue() {
        return this.message.asObservable();
    }
}